export const calculateTotalRoomNights = (bookings) =>
  bookings.reduce((sum, booking) => {
    const numberOfRooms = booking.rooms.reduce(
      (roomSum, room) => roomSum + room.numberOfRooms,
      0
    );
    return sum + booking.totaldays * numberOfRooms;
  }, 0);
